import { render, staticRenderFns } from "./Reader.vue?vue&type=template&id=0e71540c&"
import script from "./Reader.vue?vue&type=script&lang=js&"
export * from "./Reader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Reader.vue"
export default component.exports